import qs from "qs"

export const getDiscountedPrice = (price: number, discount: number) => {
  if (discount === 0) return price
  if (discount < 0 && discount > 1) {
    console.warn("Discount has to be between 0 and 1")
    return null
  }

  const newPrice = price * (1 - discount)
  return newPrice
}

export const forDisplay = {
  price: function(price: number, suffix: string) {
    return `$${price.toFixed(2)} ${suffix}`
  },
  discount: function(discount: number) {
    return `${(discount * 100).toFixed(0)}% off`
  },
  discountedPrice: function(price: number, discount: number, suffix: string) {
    return `$${getDiscountedPrice(price, discount).toFixed(2)} ${suffix}`
  },
}

export function createURL(state: Record<string, any>) {
  return `?${qs.stringify(state)}`
}

export function searchStateToURL(
  location: Location,
  searchState: Record<string, any>
) {
  return searchState ? `${location.pathname}${createURL(searchState)}` : ""
}

export function urlToSearchState({ search }: { search: string }) {
  return qs.parse(search.slice(1))
}

/*
  Borrowed from https://github.com/chodorowicz/ts-debounce
*/

type Procedure = (...args: any[]) => void

type Options = {
  isImmediate: boolean
}

export function debounce<F extends Procedure>(
  func: F,
  waitMilliseconds = 50,
  options: Options = {
    isImmediate: false,
  }
): (this: ThisParameterType<F>, ...args: Parameters<F>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  return function(this: ThisParameterType<F>, ...args: Parameters<F>) {
    const context = this

    const doLater = function() {
      timeoutId = undefined
      if (!options.isImmediate) {
        func.apply(context, args)
      }
    }

    const shouldCallNow = options.isImmediate && timeoutId === undefined

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(doLater, waitMilliseconds)

    if (shouldCallNow) {
      func.apply(context, args)
    }
  }
}
